import { schema } from '@edgevanta/db/drizzle/client';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';

export const selectStateSchema = createSelectSchema(schema.states);

export const insertStateSchema = createInsertSchema(schema.states);
